import React from 'react'
import { Helmet } from 'react-helmet-async'

export function AnimeGlossaryHelmet() {
  const siteUrl = 'https://www.anizone.co.il/anime-glossary'
  const siteName = 'AniZone'
  const title = 'מילון מושגים - המונחים שכל חובב אנימה חייב להכיר | AniZone'
  const description =
    'גלו את כל המונחים והביטויים החשובים ביותר מעולם האנימה והמנגה! מילון מושגים מקיף שיסביר לכם מה זה אוטאקו, אייסקאי, אובה ועוד.'
  const image = 'https://www.anizone.co.il/assets/glossary-cover.jpg'

  return (
    <Helmet>
      {/* 🧠 SEO בסיסי */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="אנימה, מילון מושגים, מנגה, אוטאקו, אייסקאי, מושגים באנימה, אובה, אניזון"
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={siteUrl} />

      {/* 📱 Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:site_name" content={siteName} />

      {/* 🐦 Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:url" content={siteUrl} />

      {/* 🧩 JSON-LD Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: title,
            url: siteUrl,
            description: description,
            publisher: {
              '@type': 'Organization',
              name: siteName,
              logo: {
                '@type': 'ImageObject',
                url: 'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/logo-1747045147075.webp',
              },
            },
            image: {
              '@type': 'ImageObject',
              url: image,
            },
          }),
        }}
      />
    </Helmet>
  )
}
